import React, { useState } from 'react';
import { SearchOutlined } from '@material-ui/icons';
import AfitdTextField from '../../common/elemental/AfitdTextField';
import { setClassNameInDefns } from '../../common/definitionHelper';
import { makeStyles } from '@material-ui/core';
import clsx from 'clsx';

const useStyles = makeStyles(theme => ({
    searchInput: {
        // width: '100%',
        display: 'flex',
        borderRadius: '4px',
        alignItems: 'center',
        padding: '0px 10px',
        border: '2px solid #F0F2F6',
        // maxWidth: '268px',
        height: 32,
        // background: 'rgba(0, 0, 0, 0.04)',
    },
    searchInputFocus: {
        background: '#fff',
        border: '2px solid #1D8A8B',
    },
    iconContainer: {
        cursor: 'pointer',
        width: 'auto',
        marginRight: '5px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
    icon: {
        color: '#9B9E9C',
    },
    iconActive: {
        color: '#1D8A8B',
    },
    inputSide: {
        flex: 1,

        '& fieldset': {
            display: 'none',
        },
    },
    inputSideAddress: {
        flex: 1,
        '& fieldset': {
            border: 'none',
        },
    },
    dropDown: {
        '& .MuiAutocomplete-popupIndicator': {
            display: 'none',
        },
        '& .MuiAutocomplete-input': {
            fontSize: '16px',
            fontWeight: '600',
            color: '#1D8A8B',
        },
        '& .MuiAutocomplete-input::placeholder': {
            fontWeight: '400',
            color: '#9B9E9C',
        },

        '& .MuiAutocomplete-inputRoot': {
            paddingLeft: 10,
            borderRadius: '0px',
        },
        '& .MuiInputBase-root': {
            padding: '0 !important',
        },
        '& .MuiInputBase-root input': {
            maxWidth: '80%',
        },
        '& .MuiInputBase-input': {
            padding: '10px',
        },
    },
}));

const getDefns = params => {
    const { classes, searchFocus, setSearchFocus, search, setSearch } = params;

    const { searchInput: searchInputCls, searchInputFocus: searchFocusCls, dropDown: dropDownCls, icon: IconCls, iconActive: iconActiveCls } = classes;

    const defns = {
        icon: {
            className: clsx(IconCls, { [iconActiveCls]: searchFocus }),
        },
        root: {
            className: clsx(searchInputCls, { [searchFocusCls]: searchFocus }),
        },
        searchBar: {
            value: search,
            onChange: (e, val) => setSearch(e.target.value),
            onBlur: () => setSearchFocus(false),
            onFocus: () => setSearchFocus(true),
            placeholder: 'Search',
            className: dropDownCls,
        },
    };

    // inject classes
    setClassNameInDefns(defns, classes);

    return defns;
};

const SearchInputJobSeekerDetails = props => {
    const [searchFocus, setSearchFocus] = useState(false);
    const [search, setSearch] = useState('');

    const classes = useStyles();

    const defns = getDefns({
        classes,
        props,
        searchFocus,
        setSearchFocus,
        search,
        setSearch,
    });

    return (
        <div {...defns.root}>
            <div {...defns.iconContainer}>
                <SearchOutlined {...defns.icon} />
            </div>
            <div {...defns.inputSide}>
                <AfitdTextField {...defns.searchBar} />
            </div>
        </div>
    );
};

export default SearchInputJobSeekerDetails;
